import React from "react";
import { StyledButtonPill } from "@/react/components/styled/StyledButtonPill";
import { EllipsisOverflowSpan } from "@/react/components/table/components/filter/styles";

export function DisplayFilterButton({ headerRender, displayFilter, filterFn }) {
  return (
    <StyledButtonPill size="small">
      <EllipsisOverflowSpan>{headerRender} </EllipsisOverflowSpan>
      {filterFn.displayComponent(displayFilter)}
    </StyledButtonPill>
  );
}
